import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Exercise } from 'src/app/interfaces/exercise';
import { MuscleGroup } from 'src/app/interfaces/muscle-group';
import { User } from 'src/app/interfaces/user';
import { ExerciseService } from 'src/app/services/exercise.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';

import { Modal } from 'bootstrap';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'app-exercise-list-modal',
  templateUrl: './exercise-list-modal.component.html',
  styleUrls: ['./exercise-list-modal.component.scss'],
})
export class ExerciseListModalComponent implements OnInit {
  @Output() changeEditing = new EventEmitter<any>();
  isMobile: boolean = false;

  muscleGroups: MuscleGroup[] = [];
  exercises: Exercise[] = [];
  user: User | undefined;

  constructor(
    private exerciseService: ExerciseService,
    private toastService: ToastService,
    private deviceService: DeviceDetectorService,
    private storageService: StorageService,
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    this.user = this.storageService.get('staffUser', true);

    this.getMuscleGroups();
  }

  getMuscleGroups() {
    this.exerciseService.getMuscleGroups().subscribe({
      next: (response: any) => {
        this.muscleGroups = response.muscleGroup;
      },
      error: (_error: any) => {
        this.toastService.alert(
          'No pudimos traer los Grupos Musculares de la base de datos. Si el error continua contactate con el soporte.'
        );
      },
    });
  }

  onSelectMuscleGroup(ev: any) {
    const muscleGroupId = ev.target.value;

    this.exerciseService.getExerciseByMuscleGroup(muscleGroupId).subscribe({
      next: (response: any) => {
        this.exercises = response.exercises;
        this.exercises.forEach((e) => (e.muscleGroupId = muscleGroupId));
      },
      error: (_error: any) => {
        this.toastService.alert(
          'No pudimos traer los ejercicios de la base de datos. Si el error continua contactate con el soporte.'
        );
      },
    });
  }

  openExerciseFormModal() {
    const exerciseFormModal = new Modal('#exerciseFormModal');
    this.stateService.openModal = exerciseFormModal;

    exerciseFormModal.show();
  }

  selectExercise(exercise: Exercise) {
    this.changeEditing.emit([true, exercise]);
  }

  get userIsAdmin() {
    return this.user?.role.includes('ADMIN') ? true : false;
  }
}
